<app-menu-bar></app-menu-bar>
<router-outlet></router-outlet>
